export enum ExternalInvoiceMerchantService {
  PAGO_NUBE = 'pago_nube',
}
